import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <h1 className="text-5xl font-bold text-navy mb-6">
              Terms of Service
            </h1>
            <p className="text-sm text-gray-600">
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        <section className="py-12 pb-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-navy mb-4">Agreement to Terms</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                By accessing or using our services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Description of Services</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We provide funding strategy and business credit consulting services. Our services include fundability assessments, credit profile optimization, business structure guidance, and strategic positioning for funding applications. We are not a lender and do not provide funding directly.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">User Responsibilities</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                When using our services, you agree to:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2 text-base text-gray-700">
                <li>Provide accurate, complete, and current information</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Not misrepresent your identity or provide false information</li>
                <li>Follow our guidance and recommendations in good faith</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
              </ul>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">No Guarantee of Results</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                While we provide professional consulting services and strategic guidance, we cannot and do not guarantee specific results, including but not limited to funding approvals, credit score improvements, or specific funding amounts. Results vary based on individual circumstances, lender criteria, and factors beyond our control.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Fees and Payment</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Fees for our services will be clearly communicated before you engage our services. Payment terms, refund policies, and cancellation policies will be outlined in your service agreement. All fees are non-refundable unless otherwise specified in writing.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Intellectual Property</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                All content, materials, strategies, and methodologies provided through our services are our intellectual property and are protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Confidentiality</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We maintain strict confidentiality of your personal and financial information. However, you acknowledge that we may need to share certain information with service providers, lenders, or other parties as necessary to provide our services, always under appropriate confidentiality agreements.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Limitation of Liability</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Indemnification</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                You agree to indemnify and hold us harmless from any claims, damages, losses, liabilities, and expenses (including legal fees) arising from your use of our services, your violation of these terms, or your violation of any rights of another party.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Termination</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We reserve the right to terminate or suspend your access to our services at any time, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties, or for any other reason at our sole discretion.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Governing Law</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                These Terms of Service shall be governed by and construed in accordance with the laws of the jurisdiction in which we operate, without regard to its conflict of law provisions.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Changes to Terms</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new Terms of Service on this page and updating the "Last Updated" date. Your continued use of our services after such modifications constitutes your acceptance of the updated terms.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Contact Information</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                If you have any questions about these Terms of Service, please contact us through the information provided on our website.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
